import { Box, IconButton, type SpeedDialActionProps, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SpeedDialAction } from "components";
import { featuresConfig } from "config/features";

import { useStepBack } from "./useStepBack";

type Props = SpeedDialActionProps & {
    position?: { top?: number; right?: number; bottom?: number; left?: number };
    newDesign?: boolean;
};

export function StepBack({ position, newDesign, ...speedDialProps }: Props) {
    const { t } = useTranslation();
    const { nameKey, Icon } = featuresConfig["stepBack"];
    const { stepBack, canStepBack } = useStepBack();

    const handleClick = () => {
        stepBack();
    };

    const disabled = !canStepBack;

    if (newDesign) {
        return (
            <Tooltip title={t(nameKey)} placement="top">
                <Box>
                    <IconButton disabled={disabled} onClick={handleClick}>
                        <Icon />
                    </IconButton>
                </Box>
            </Tooltip>
        );
    }

    return (
        <SpeedDialAction
            {...speedDialProps}
            data-test="step-back"
            FabProps={{
                disabled,
                ...speedDialProps.FabProps,
                style: { ...position, position: "absolute" },
            }}
            onClick={handleClick}
            title={disabled ? undefined : t(nameKey)}
            icon={<Icon />}
        />
    );
}
